import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import React from 'react'

import AudioPlayer from '@/app/component/atom/audio-player'
import { TGetFileFunction } from '@/app/module/conversations/types'

type Props = {
  audioUrl?: string
  message: string
  getFile: TGetFileFunction
  partId: string | number
}

const WhatsappAudio: React.FC<Props> = ({ audioUrl, message, getFile, partId }) => {
  const [file, setFile] = React.useState('')
  const [loading, setLoading] = React.useState(false)

  return (
    <>
      {audioUrl && (
        <AudioPlayerCont>
          <AudioPlayer
            loading={loading}
            playId={String(partId)}
            source={file}
            onPlayToggle={(val: string) => {
              if (val && !file) {
                setLoading(true)
                getFile(audioUrl).then((res) => {
                  setFile(res.url)
                  setLoading(false)
                })
              }
            }}
          />
        </AudioPlayerCont>
      )}
      <Typography style={{ whiteSpace: 'pre-line' }}>{message}</Typography>
    </>
  )
}

const AudioPlayerCont = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})

export default WhatsappAudio
